import * as ss from 'superstruct';

/** 1 to `max` characters, not all whitespace. */
export const NonBlankString = (max: number) =>
  ss.refine(
    ss.size(ss.string(), 1, max),
    'NonBlank',
    (value) => value.trim() !== '' || 'Must not be blank',
  );
